import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import Layout from '../../components/Layout';
import MediaDropZone from "../../components/Media/DropZone";

import {
    withPaginator,
    Pagination
} from '../../components/Pagination';
import {Divider} from '@material-ui/core';

const FileIndex = ({classes, items: entities, uploadConfig, isArchive, order}) => (
    <Layout>
        <MediaDropZone
            uploadConfig={uploadConfig}
            order={order}
        >
            <Divider />
            <Pagination colSpan={6} table={false} classes={{spacer: "none"}}/>
        </MediaDropZone>
    </Layout>
);

const styles = theme => ({
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(
    withPaginator('entities')(FileIndex)
);
